import React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { useSet } from 'react-use';
import { Accordion } from '../../../../../../../CommonComponents/OPL/Accordion/Accordion/Accordion';
import { AccordionButton } from '../../../../../../../CommonComponents/OPL/Accordion/AccordionButton/AccordionButton';
import { Box } from '../../../../../../../CommonComponents/OPL/Box/Box';
import { Button } from '../../../../../../../CommonComponents/OPL/Button/Button';
import { IconButton } from '../../../../../../../CommonComponents/OPL/IconButton/IconButton';
import { EmploymentFormFields } from '../../../../../../../ProfileOPL/Income/forms/Employment/EmploymentFormFields';
import { StyledAccordionPanel } from '../../WhatIf.styles';
import { DEFAULT_INCOME, FormValues } from './IncomeChange.meta';
import { IncomeOptionsDTO } from '../../../../../../../ProfileOPL/Income/api/useIncomeQuery';

interface IncomeProps {
  options: IncomeOptionsDTO;
}

export const IncomeChange = ({ options }: IncomeProps) => {
  const [, { has: isIncomeCollapsed, toggle: toggleIncome }] = useSet<string | null>();

  const formContext = useFormContext<FormValues>();

  const { control, watch } = formContext;

  const { fields, append: appendIncome, remove: removeIncome } = useFieldArray({
    control,
    name: 'Incomes',
  });

  const watchIncomes = watch('Incomes');

  const incomes = fields.map((field, index) => ({
    ...field,
    ...watchIncomes[index],
  }));

  return (
    <>
      <Accordion isActive={false} css="border: none; border-radius: 0; ">
        {incomes.map((income, index) => {
          const buttonId = `what-if-income--accordion-button--${income.id}`;
          const panelId = `what-if-income--accordion-panel--${income.id}`;

          return (
            <React.Fragment key={income.id}>
              <AccordionButton
                id={buttonId}
                panelId={panelId}
                isActive={!isIncomeCollapsed(income.id)}
                onClick={() => toggleIncome(income.id)}
                extra={
                  !income.IsBasePlanIncome && (
                    <IconButton
                      variant="subtleInactive"
                      icon="far fa-minus-circle"
                      onClick={() => removeIncome(index)}
                    />
                  )
                }
              >
                {`Income ${index + 1}`}
              </AccordionButton>

              <StyledAccordionPanel
                id={panelId}
                buttonId={buttonId}
                isActive={!isIncomeCollapsed(income.id)}
              >
                <Box display="flex" flexDirection="column" gridGap="16" px="16" pb="32">
                  <EmploymentFormFields
                    formBag={formContext}
                    options={options}
                    fieldNamePrefix={`Incomes.${index}.`}
                  />
                </Box>
              </StyledAccordionPanel>
            </React.Fragment>
          );
        })}
      </Accordion>

      <Button
        variant="link"
        leftIcon="fas fa-plus"
        onClick={() => appendIncome({ ...DEFAULT_INCOME, Earner: options.OwnerOptions[0] })}
        my="24"
        ml="16"
      >
        {`Add ${incomes.length > 0 ? 'another ' : ''}income`}
      </Button>
    </>
  );
};
